let connect = require("react-redux").connect;
import React from "react";

let actions = require("../actions/actions");

class ModerationSuspendedSearch extends React.Component {
    render() {
        return (
            <section className="creator-search">
                <div className="input-group input-group-lg">
                    <span className="input-group-addon" id="sizing-addon1">
                        <div className="ui_search" />
                    </span>
                    <input
                        type="text"
                        className="form-control search-input"
                        ref="search-suspended"
                        placeholder="Search for Suspended Uploads..."
                        aria-describedby="sizing-addon1"
                        onKeyUp={this.searchSuspended.bind(this)}
                    />
                </div>
            </section>
        );
    }

    searchSuspended(e) {
        let searchTerm = encodeURIComponent(
            this.refs["search-suspended"].value
        );
        if (searchTerm === "") {
            this.props.fetchSuspendedUploads("");
        } else if (searchTerm.length > 2) {
            this.props.searchSuspendedUploads(searchTerm);
        }
    }
}

module.exports = connect(null, {
    fetchSuspendedUploads: actions.fetchSuspendedUploads,
    searchSuspendedUploads: actions.searchSuspendedUploads
})(ModerationSuspendedSearch);
